import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { changeProfilePicture, updateProfile } from "../../services/api";
import { setRefetch, setUserData } from "../../store/reducers/listingReducer";
import { Spinner } from "../ui/Spinner";
import { ErrorMessage, Field, useFormik } from "formik";
import { baseQueryAPI } from "../../services/baseQuery";

export const PostMail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state: any) => state.listingReducer.userData);
  const inputRef = useRef<HTMLInputElement>(null);

  const [file, setFile] = useState<File | undefined>();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [settingId, setSettingId] = useState<number | null>(null);

  const { data: settingsData } = baseQueryAPI.useGetPostMailSettingsQuery({
    team_id: userData.team_id,
  });

  useEffect(() => {
    if (settingsData && settingsData?.data.id) {
      setSettingId(settingsData?.data.id);
    }
  }, [settingsData]);

  const [createSetting] = baseQueryAPI.useCreatePostMailSettingsMutation();
  const [updateSetting] = baseQueryAPI.useUpdateSettingsMutation();

  const formik = useFormik({
    initialValues: {
      team_id: userData.team_id,
      from_address: settingsData?.data?.fromAddress || "",
      bank_name: settingsData?.data?.bankName || "",
      phone_number: settingsData?.data?.phoneNumber || "",
    },
    onSubmit(values) {
      console.log(values);
      if (settingId) {
        updateSetting({
          id: settingId,
          ...values,
        });
      } else {
        createSetting(values);
      }
    },
    enableReinitialize: true,
  });

  async function changeProfileData(values: any) {
    setLoading(true);
    try {
      const submitValues = { ...values };
      submitValues.sms = submitValues.sms ? 1 : 0;
      submitValues.phone = `${submitValues.country} ${submitValues.phone}`;
      const formData = new FormData();
      Object.keys(submitValues).forEach((key) =>
        formData.append(key, submitValues[key])
      );
      if (file) {
        formData.append("file", file);
      }
      formData.append(
        "notification_frequency",
        userData.user_preference?.notification_frequency || "every_10_listings"
      );
      let changeResponse = await updateProfile(formData);
      if (changeResponse) {
        dispatch(setUserData(changeResponse.data.data));
      }

      dispatch(setRefetch(true));
      setLoading(false);
    } catch (e) {
      console.error(e);
      setErrorMessage("Upload failed. Please try again.");
      setLoading(false);
    }
  }

  return (
    <div className="w-full p-6">
      <form onSubmit={formik.handleSubmit}>
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold text-gray-900">Post Mail</h3>
          <div className="flex">
            <button
              className="bg-primary px-4 py-2 text-white font-semibold text-sm flex gap-x-3"
              disabled={loading}
              type="submit"
            >
              {loading ? <Spinner /> : null}
              Save
            </button>
            <button onClick={() => navigate("/")} className="h-10 w-10">
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
        </div>

        <div className="mt-6">
          <div className="flex gap-x-8">
            <div className="grid grid-cols-2 gap-4 flex-1">
              <div className="flex flex-col col-span-2 gap-y-2">
                <label
                  htmlFor="primary-name"
                  className="text-sm font-medium text-gray-700"
                >
                  From Address
                </label>
                <textarea
                  className="border px-4 py-2 outline-none"
                  name="from_address"
                  id="from_address"
                  rows={5}
                  onChange={formik.handleChange}
                  value={formik.values.from_address}
                />
              </div>

              <div className="flex flex-col gap-y-2">
                <label
                  className="text-sm font-medium text-gray-700"
                  htmlFor="primary-name"
                >
                  Bank Name
                </label>
                <input
                  className="border px-4 py-2 outline-none"
                  type="text"
                  name="bank_name"
                  id="bank_name"
                  onChange={formik.handleChange}
                  value={formik.values.bank_name}
                />
              </div>

              <div className="flex flex-col gap-y-2">
                <label
                  className="text-sm font-medium text-gray-700"
                  htmlFor="primary-name"
                >
                  Phone Number
                </label>
                <input
                  className="border px-4 py-2 outline-none"
                  type="text"
                  name="phone_number"
                  id="phone_number"
                  onChange={formik.handleChange}
                  value={formik.values.phone_number}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
